var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "svea-product", on: { click: _vm.modalCloseTouch } },
    [
      _c(
        "div",
        {
          staticClass: "svea-product__modal",
          class: { "svea-product__modal-open": _vm.isModalOpen },
        },
        [
          _vm.isTouchDevice
            ? _c(
                "div",
                {
                  staticClass: "svea-product__modal-close",
                  on: { click: _vm.modalCloseTouch },
                },
                [_vm._v("Stäng")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "svea-product__modal-container",
              attrs: { href: _vm.modalLink },
            },
            [
              _c("img", {
                staticClass: "svea-product__modal-img",
                attrs: { src: _vm.modalImg, alt: "Picture of the item" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "svea-product__modal-text" }, [
                _c("h3", {
                  staticClass: "svea-product__modal-name",
                  domProps: { textContent: _vm._s(_vm.modalTitle) },
                }),
                _vm._v(" "),
                _c("p", {
                  staticClass: "svea-product__modal-description",
                  domProps: { textContent: _vm._s(_vm.modalDescription) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "svea-product__modal-data" }, [
                  _c("p", {
                    staticClass:
                      "svea-product__row-price svea-product__modal-price",
                    domProps: { innerHTML: _vm._s(_vm.modalPrice) },
                  }),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass:
                        "svea-product__row-stock svea-product__modal-stock",
                      class: {
                        "svea-product__row-instock": _vm.modalStock,
                        "svea-product__row-orderonly": !_vm.modalStock,
                      },
                    },
                    [_vm._v(_vm._s(_vm.modalStockStatus))]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "svea-product__left" },
        [
          _vm.showGallery
            ? _c(
                "div",
                { staticClass: "svea-product__gallery" },
                _vm._l(_vm.images, function (im, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "svea-product__gallery-image",
                      class: {
                        "svea-product__gallery-image-selected":
                          index === _vm.selectedImage,
                      },
                      on: {
                        mouseover: function ($event) {
                          $event.preventDefault()
                          return _vm.setGalleryImage(index)
                        },
                      },
                    },
                    [_c("div", [_c("img", { attrs: { src: im, alt: "" } })])]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "svea-product__image" }, [
            _c(
              "div",
              {
                on: {
                  click: function ($event) {
                    _vm.zoom = true
                  },
                },
              },
              [
                _c("img", { attrs: { src: _vm.image, alt: "" } }),
                _vm._v(" "),
                _vm.product.badge
                  ? _c("badge", {
                      attrs: {
                        badge: _vm.product.badge_settings,
                        bigBadge: true,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.zoom,
                    expression: "zoom",
                  },
                ],
                staticClass: "svea-product-zoom__modal",
                on: {
                  click: function ($event) {
                    _vm.zoom = false
                  },
                },
              },
              [
                _c("div", { staticClass: "svea-product-zoom__wrapper" }, [
                  _c(
                    "button",
                    {
                      staticClass: "svea-product-zoom__close",
                      on: {
                        click: function ($event) {
                          _vm.zoom = false
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            fill: "black",
                          },
                        },
                        [
                          _c("path", {
                            attrs: { fill: "none", d: "M0 0h24v24H0z" },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("img", { attrs: { src: _vm.image, alt: "" } }),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "svea-product__right" },
        [
          _c(
            "div",
            { staticClass: "svea-product__taxonomies" },
            [
              _vm.category
                ? _c("DisplayTaxo", { attrs: { taxonomy: _vm.category } })
                : _vm._e(),
              _vm._v(" "),
              _vm.trademark
                ? _c("DisplayTaxo", { attrs: { taxonomy: _vm.trademark } })
                : _vm._e(),
              _vm._v(" "),
              _vm.supplier
                ? _c("DisplayTaxo", { attrs: { taxonomy: _vm.supplier } })
                : _vm._e(),
              _vm._v(" "),
              _vm.designer
                ? _c("DisplayTaxo", { attrs: { taxonomy: _vm.designer } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("h3", { staticClass: "svea-product__name" }, [
            _vm._v(_vm._s(_vm.product.title)),
          ]),
          _vm._v(" "),
          _c("expand-text", {
            staticClass: "svea-product__description",
            attrs: { text: _vm.product.description },
          }),
          _vm._v(" "),
          _vm.product.metadata
            ? _c("div", { staticClass: "svea-product__metadata" }, [
                _c("hr"),
                _vm._v(" "),
                _c("h6", { staticClass: "svea-product__metadata-title" }, [
                  _vm._v("Egenskaper"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "svea-product__metadata-container" },
                  [
                    _vm.sku
                      ? _c(
                          "div",
                          { staticClass: "svea-product__metadata-data" },
                          [
                            _vm._v("\n          Artikelnummer: "),
                            _c("span", [_vm._v(_vm._s(_vm.sku))]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.product.metadata, function (meta, key) {
                      return _c(
                        "div",
                        {
                          key: key,
                          staticClass: "svea-product__metadata-data",
                        },
                        [
                          key !== "additional_search_terms" &&
                          key !== "index_type"
                            ? _c("div", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.metadataLabel(key)) +
                                    ": "
                                ),
                                _c("span", [_vm._v(_vm._s(meta))]),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.secondTaxonomyGroup, function (taxonomy) {
                      return _c("DisplayTaxo", {
                        key: taxonomy.slug,
                        attrs: { taxonomy: taxonomy, attribute: true },
                      })
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("hr"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "svea-product__container" },
            [
              _vm.hasVariations
                ? _c(
                    "div",
                    _vm._l(_vm.product.attributes, function (attribute, slug) {
                      return _c(
                        "div",
                        { key: slug, staticClass: "svea-product__variations" },
                        [
                          _c(
                            "ul",
                            { staticClass: "svea-product__variations-list" },
                            _vm._l(attribute.terms, function (term) {
                              return _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.isDropdownOpen(slug) ||
                                        _vm.isSelected(slug, term.slug),
                                      expression:
                                        "isDropdownOpen(slug) || isSelected(slug, term.slug)",
                                    },
                                  ],
                                  key: term.slug,
                                  staticClass: "svea-product__variations-item",
                                  class: {
                                    "svea-product__variations-opened":
                                      _vm.isDropdownOpen(slug),
                                    "svea-product__variations-selected":
                                      _vm.isSelected(slug, term.slug),
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.isDropdownOpen(slug)
                                        ? _vm.selectAttribute(slug, term.slug)
                                        : _vm.openDropdown(slug)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(term.name) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "svea-product__row" }, [
                _c(
                  "span",
                  {
                    staticClass: "svea-product__row-stock",
                    class: {
                      "svea-product__row-instock": _vm.inStock,
                      "svea-product__row-orderonly": !_vm.inStock,
                    },
                  },
                  [_vm._v(_vm._s(_vm.stockStatus))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "svea-product__row-quantity" }, [
                  _c(
                    "button",
                    {
                      staticClass: "svea-product__row-controls",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.minus.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n            -\n          ")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "svea-product__row-value" }, [
                    _vm._v(
                      "\n            " + _vm._s(_vm.quantity) + "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "svea-product__row-controls",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.plus.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n            +\n          ")]
                  ),
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "svea-product__row-price",
                  domProps: { innerHTML: _vm._s(_vm.price) },
                }),
              ]),
              _vm._v(" "),
              _vm.product.cross_sell.length
                ? _c(
                    "div",
                    { staticClass: "svea-product__cross-sell" },
                    [
                      _c("h6", [_vm._v("Köp till")]),
                      _vm._v(" "),
                      _vm._l(_vm.product.cross_sell, function (extra) {
                        return _c(
                          "div",
                          {
                            key: extra.id,
                            staticClass: "svea-product__cross-sell__container",
                          },
                          [
                            _c("div", { staticClass: "checkbox" }, [
                              _c("input", {
                                attrs: { type: "checkbox" },
                                on: {
                                  change: function ($event) {
                                    return _vm.toggleExtra($event, extra.id)
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "touch",
                                    rawName: "v-touch",
                                    value: _vm.touchDevice,
                                    expression: "touchDevice",
                                  },
                                ],
                                attrs: { href: extra.link },
                                on: {
                                  mouseover: function ($event) {
                                    return _vm.modalOpen(extra)
                                  },
                                  mouseleave: function ($event) {
                                    return _vm.modalClose(true)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(extra.name))]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(" " + _vm._s(extra.price) + " kr."),
                            ]),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.loading
                ? _c(
                    "button",
                    {
                      staticClass:
                        "svea-product__cta svea-product__cta-loading",
                      attrs: { disabled: true },
                    },
                    [_c("span", { staticClass: "spinner" })]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "svea-product__cta",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.addToCart.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v("\n        Lägg i varukorgen\n        "),
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            fill: "#000",
                          },
                        },
                        [
                          _c("path", {
                            attrs: { fill: "none", d: "M0 0h24v24H0z" },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M6.5 2h11a1 1 0 01.8.4L21 6v15a1 1 0 01-1 1H4a1 1 0 01-1-1V6l2.7-3.6a1 1 0 01.8-.4zm12 4L17 4H7L5.5 6h13zM9 10H7v2a5 5 0 0010 0v-2h-2v2a3 3 0 01-6 0v-2z",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("klarna-placement", {
                pre: true,
                attrs: {
                  "data-key": "credit-promotion-auto-size",
                  "data-locale": "sv-SE",
                  "data-purchase-amount": "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "svea-product__info" }, [
      _c("li", [_vm._v("Fri frakt över 1000kr")]),
      _vm._v(" "),
      _c("li", [_vm._v("Lagervaror skickas samma vardag")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/SingleProduct.vue